import { runInSandbox } from '@epicuro-next/addons/sandbox';
import { AbstractLoggerService } from '@epicuro-next/models/platform/monitoring';
import { of, TimeoutError } from 'rxjs';
import { catchError, take, timeout } from 'rxjs/operators';

export function createValidationRun<T>(
  validationFunction: string,
  validationArguments: object = {},
  loggerService: AbstractLoggerService,
  timeoutValue = 2000,
) {
  const validationScriptToRun = `(function () {
        const validationArguments = ${JSON.stringify(validationArguments)};
        ${validationFunction}
        return validate(validationArguments);
      })();
    `;

  return runInSandbox<T[]>(of(validationScriptToRun)).pipe(
    timeout(timeoutValue),
    take(1),
    catchError((error) => {
      let loggedError: Error;
      if (error instanceof TimeoutError) {
        loggedError = new Error(
          'User validation scripts timed out: ' + validationFunction,
        );
      } else {
        loggedError = new Error(
          'User validations scripts failed with: ' + error.error,
        );
      }

      console.error(`runInSandbox Error ${loggedError}`);
      loggerService.exception({
        error: loggedError,
      });
      return of([]);
    }),
  );
}
